import React from 'react';

const Tag = ({children}) => {
    return (
        <div className="inline-flex items-center gap-2 px-4 py-1 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 text-white font-semibold rounded-full shadow-md transition-transform duration-200">
            <span className="text-sm">{children}</span>
        </div>
    );
}

export default Tag